import React from 'react';
import FormattedCurrency from '../common/FormattedCurrency';
import { Button } from '../common/Button';

export interface UpsertQuoteModalActionsProps {
  myButtons: {
    label: string;
    variant: 'primary' | 'transparent-with-border' | 'simple-text';
    onClick: () => void;
    className: string;
    type: 'submit' | 'button';
    disabled?: boolean;
  }[];
  saveError?: string | null;
  canSubmit: boolean;
  submitDisabledReason?: string;
  totalAmount: number;
  totalAmountLabel: string;
  showTotalAmount?: boolean;
}

export const UpsertQuoteModalActions: React.FC<UpsertQuoteModalActionsProps> = ({
  myButtons,
  saveError,
  canSubmit,
  submitDisabledReason,
  totalAmount,
  totalAmountLabel,
  showTotalAmount = true,
}) => (
  <>
    {showTotalAmount && (
      <div className="flex flex-col gap-2 mt-6 md:mt-4">
        <h3 className="text-xl font-bold text-secondary">{totalAmountLabel}</h3>
        <div className="text-2xl font-bold text-secondary-light">
          <FormattedCurrency value={totalAmount} />
        </div>
      </div>
    )}
    {saveError && (
      <div className="flex text-[#F04438] text-[0.9375rem] font-ambit mt-4 md:flex-row-reverse md:items-center">
        {saveError}
      </div>
    )}
    <div className="flex flex-col gap-4 mt-8 md:flex-row-reverse md:items-center md:mt-4">
      {myButtons.map(button => (
        <Button
          key={button.label}
          type={button.type}
          onClick={button.onClick}
          variant={button.variant}
          className={button.className}
          disabled={button.disabled}
        >
          {button.label}
        </Button>
      ))}
    </div>
    {!canSubmit && submitDisabledReason && (
      <div className="flex flex-col md:w-full md:flex-row-reverse">
        <p className="text-secondary-light text-base md:max-w-[15rem] md:justify-end">
          {submitDisabledReason}
        </p>
      </div>
    )}
  </>
);
